/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @nx/enforce-module-boundaries */
import { GetServerSideProps } from 'next';
import DOMPurify from 'isomorphic-dompurify';
import { PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';
import {
  hasErrorQueryFlag,
  scrubErrorTextFromModel,
  updateRobotMetaNames,
  findComponentByType,
  constructFAQJsonSchema,
  safeJsonLdStringify,
} from '@marriott/mi-offers-components';

import { envVarKeys } from '../../_constants/envVarKeys';
import OfferSignatures from '../../signatures/offerSignatures.json';

function pageRenderer(props: any) {
  console.log('[offers.tsx] props ', props);
  const hasErrorFlag = hasErrorQueryFlag(props?.query ?? {});

  if (!hasErrorFlag) {
    scrubErrorTextFromModel(props?.model);
  }

  if (props.productSpecificResponse === undefined && hasErrorFlag && props.model?.metaNames) {
    const mappedMetaNames = updateRobotMetaNames(props.model.metaNames);
    props.model['metaNames'] = mappedMetaNames;
  }
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const offersSpecificData = async () => {
  const [featureFlags, featureFlagLogo, featureFlagAemltsHost] = await Promise.all([
    // Feature flag call for MBOP
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_MBOP, {
      target: TARGETS.APP.OFFERS_RENDERER,
    }),
    // Feature flag call for logo automation
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
      target: TARGETS.APP.OFFERS_RENDERER,
    }),
    // Feature flag to switch AEM host to LTS host
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_OFFERS_RENDERER_AEMLTS_HOST, {
      target: TARGETS.APP.OFFERS_RENDERER,
      enableStream: true,
    }),
  ]);
  const useAemLtsHost = featureFlagAemltsHost?.experience_mcom_offers_renderer_aemlts_host;
  const aemHost = useAemLtsHost ? process.env.NEXT_PUBLIC_AEM_LTS_HOST : process.env.NEXT_PUBLIC_AEM_HOST;

  return {
    operationSignatures: OfferSignatures,
    featureFlagAemltsHost: featureFlagAemltsHost ?? null,
    aemHost: aemHost ?? null,
    nextPublicEnvKeys: [...Object.keys(envVarKeys)],
    featureFlags: { featureFlags, featureFlagLogo },
  };
};

const postAEMModelOperations = async (...args: any[]) => {
  const [, , , model] = args;
  const enableWebSDK = String(model?.enableWebSDK);
  const offersAccordionContainerEnhanced = findComponentByType(
    model?.cqItems,
    'mi-aem-offers-spa/components/offersaccordioncontainerenhanced'
  );

  const items = (offersAccordionContainerEnhanced?.cqItems || offersAccordionContainerEnhanced?.[':items']) ?? {};
  const headerListItems = offersAccordionContainerEnhanced?.headerListItems ?? [];
  const jsonLdData = constructFAQJsonSchema(headerListItems, items);
  const sanitizedJsonLdData = jsonLdData
    ? (
        DOMPurify.sanitize(safeJsonLdStringify(jsonLdData), {
          ALLOWED_TAGS: [],
          ALLOWED_ATTR: [],
          RETURN_DOM: true,
        }) as Node
      ).textContent ?? ''
    : '';
  model.sanitizedJsonLdDataFAQ = sanitizedJsonLdData;
  if (enableWebSDK === 'true' && process.env['NEXT_PUBLIC_ENABLE_WEBSDK'] === 'true') {
    const ENABLE_CLIENT_DATA_LAYER = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_RTP_ENABLE_ACDL, {
      target: TARGETS.APP.OFFERS_RENDERER,
    });
    return {
      ...model,
      ENABLE_ACDL: ENABLE_CLIENT_DATA_LAYER?.experience_mcom_rtp_enable_acdl,
    };
  } else {
    return {
      ...model,
      ENABLE_ACDL: false,
    };
  }
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
export const getServerSideProps: GetServerSideProps<any> = prePageCall(
  offersSpecificData,
  undefined,
  false,
  false,
  false,
  undefined,
  postAEMModelOperations
);
export default pageRenderer;
